<div class="grid grid-cols-4 gap-4 items-end">
  <div nz-col nzSpan="6">
    <label class="form-label required">Therapists</label>
    <nz-select
      [(ngModel)]="selectedTherapists"
      class="w-[100%] mr-1"
      nzAllowClear
      nzPlaceHolder="Select a Therapists"
      nzShowSearch
      (ngModelChange)="therapistFilterFn($event)"
    >
      <nz-option
        *ngFor="let therapist of therapists"
        [nzLabel]="therapist.label"
        [nzValue]="therapist.value"
      ></nz-option>
    </nz-select>
  </div>
  <div>
    <button nz-button class="save" nzType="primary" (click)="resetFilter()">
      Reset Filter
    </button>
  </div>
</div>

<nz-spin [nzSpinning]="tableSpinner">
  <div nz-row>
    <nz-tabset (nzSelectChange)="tabChange($event)">
      <nz-tab nzTitle="Upcoming Sessions">
        <div class="p-6">
          <app-calender
            [markers]="this.markers"
            (monthChange)="filterByRange($event)"
            [markerTpl]="markerTpl"
          ></app-calender>
        </div>

        <ng-template #markerTpl let-data>
          <div class="flex items-center justify-center bg-transparent">
            <ul
              class="flex flex-col gap-1 container bg-transparent -translate-y-4"
            >
              @for (marker of data; track marker) {
                <li
                  (click)="showModal(marker.data.sessionDetails,marker.data.therapistName +
                  '(' +
                  marker.data.sessionTime +
                  ')' + '-' + formatSessionDate(marker.date))"
                  class="flex bg-blue-100 text-center text-black text-xs rounded-md px-2 py-1 justify-center items-center cursor-pointer"
                >
                  {{
                    marker.data.therapistName +
                      "(" +
                      marker.data.sessionTime +
                      ")"
                  }}
                </li>
              }
            </ul>
          </div>
        </ng-template>
      </nz-tab>
      <nz-tab nzTitle="All Sessions">
        <div class="p-6">
          <app-calender
            [markers]="this.markers"
            (monthChange)="filterByRange($event)"
            [markerTpl]="markerTpl"
          ></app-calender>
        </div>
        <ng-template #markerTpl let-data>
          <div class="flex items-center justify-center bg-transparent">
            <ul
              class="flex flex-col gap-1 container bg-transparent -translate-y-4"
            >
              @for (marker of data; track marker) {
                <li
                  (click)="showModal(marker.data.sessionDetails,marker.data.therapistName +
                  '(' +
                  marker.data.sessionTime +
                  ')'+ '-' + formatSessionDate(marker.date))"
                  class="flex bg-blue-100 text-center text-xs text-black rounded-md px-2 py-1 justify-center items-center cursor-pointer"
                >
                  {{
                    marker.data.therapistName +
                      "(" +
                      marker.data.sessionTime +
                      ")"
                  }}
                </li>
              }
            </ul>
          </div>
        </ng-template>
      </nz-tab>
    </nz-tabset>
  </div>
</nz-spin>
<nz-drawer
  [nzClosable]="true"
  [nzVisible]="isVisible"
  nzPlacement="bottom"
  [nzTitle]="sessionDetailTitle"
  (nzOnClose)="handleCancel()"
>
  <ng-container *nzDrawerContent>
    <nz-table
      #sessionTable
      [nzScroll]="{ y: '500px' }"
      class="mt-5"
      [nzData]="sessionData"
      nzFrontPagination="false"
      [nzTotal]="0"
      [nzPageSize]="5"
      [nzBordered]="true"
      [nzShowSizeChanger]="true"
      nzTableLayout="fixed"
    >
      <thead>
        <tr>
          <th>Client Details</th>
          <th>Partner Details</th>
          <th>Session Timing</th>
          <th>Therapist Details</th>
          <th>Session Status</th>
          <th>Plan Details</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let data of sessionTable.data">
          <tr>
            <td
            >
              {{ data.clientDetails.name }}<br />
              {{ data.clientDetails.email }}<br />
              <div >
                {{ data.id }}
                <br />
                Gender: {{ data.clientDetails.gender }} <br />Phone:
                {{ data.clientDetails.phone }}<br />
                PartnerId: {{ data.clientDetails.partnerId }}
                <br />
                PartnerName: {{ data.clientDetails.partnerName }}
              </div>
            </td>
            <td>
              {{ data.clientDetails.partnerId }}
              <br />
              {{ data.clientDetails.partnerName }}
              <br />
              <nz-tag
                *ngIf="data.clientDetails.partnerId === 'PR-9008'"
                nzColor="cyan"
                >Retail User</nz-tag
              >
              <nz-tag
                *ngIf="data.clientDetails.partnerId !== 'PR-9008'"
                nzColor="cyan"
                >Corporate User</nz-tag
              >
            </td>
            <td>
              <div *ngIf="data.appointmentRequestDate" nz-row nzJustify="start">
                Requested Date:
                {{ formatSessionDate(data.appointmentRequestDate) }}
              </div>
              <div nz-row nzJustify="start">
                Session Date: {{ formatSessionDate(data.sessionDate) }}
              </div>
              <div nz-row nzJustify="start">
                {{ formatSessionTime(data.sessionStart) }} -
                {{ formatSessionTime(data.sessionEnd) }}
              </div>
              <div>
                <div
                  *ngIf="data.appointmentConfirmedDate"
                  nz-row
                  nzJustify="start"
                >
                  Confirmed Date:
                  {{ formatSessionDate(data.appointmentConfirmedDate) }}
                </div>
                <div
                  *ngIf="data.appointmentConfirmedBy"
                  nz-row
                  nzJustify="start"
                >
                  Confirmed By: {{ data.appointmentConfirmedBy }}
                </div>
                <div
                  *ngIf="data.appointmentCancellationDate"
                  nz-row
                  nzJustify="start"
                >
                  Cancelled Date:
                  {{ formatSessionDate(data.appointmentCancellationDate) }}
                </div>
                <div
                  *ngIf="data.appointmentCancelledBy"
                  nz-row
                  nzJustify="start"
                >
                  Cancelled By: {{ data.appointmentCancelledBy }}
                </div>
              </div>
            </td>
            <td>
              <div>
                {{
                  data.therapistDetails.therapistName
                }}
                <br />
                {{ data.therapistDetails.therapistEmail }}
                <br />
                {{ data.therapistDetails.therapistPhone }}
                <br />
                {{ data.callLink }}
              </div>
            </td>
            <td>
              {{ data.sessionStatus }}
              <nz-tag *ngIf="data.offline" nzColor="red">Offline</nz-tag>
            </td>
            <td>
              <div
                *ngIf="data.planSubcriptionId"
              >
                Plan Subcription Id : {{ data.planSubscriptionDetails?.id }}
                <br />
                Plan Name:
                <u class="cursor-pointer">
                  {{ data.planSubscriptionDetails?.planName }} </u
                ><br />Purchased Date :
                {{
                  utils.convertEpochToFormattedDate(
                    data.planSubscriptionDetails?.purchasedAt!
                  )
                }}
                <br />
                Validity:
                {{
                  utils.convertEpochToFormattedDate(
                    data.planSubscriptionDetails?.validTill!
                  )
                }}
                <br />
                Payment Type:
                {{
                  utils.convertToTitleCase(
                    data.planSubscriptionDetails?.paymentType!
                  )
                }}
                <br />
                Verticle : {{ data.planSubscriptionDetails?.vertical }}
                <br />
                Concern : {{ data.planSubscriptionDetails?.concern }}
                <br />
                No of Session: {{ data.planSubscriptionDetails?.noOfSessions }}
              </div>
              <div>
                <h1>Testimonial :</h1>
                <br />
                {{ data.testimonial }}
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </nz-table>
  </ng-container>
</nz-drawer>
